// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"57ed91d5","553":"cb763487"}[chunkId] + ".chunk.css";
};